<template>
    <div class="modal modal--confirm" v-bind:class="{ 'is-open' : isOpen }">
        <div class="modal__dialog">
            <div class="modal__content">
                {{ __('Are you sure you wish to copy this tile?') }}
                <div class="has-margin-t30 has-text-left">
                    <label class="form__label" v-bind:for="'copyToStartdesk' + tile.id">{{ __('Copy to startdesk') }}</label>
                    <select class="form__control" v-bind:id="'copyToStartdesk' + tile.id"
                            v-model="selectedStartdesk"
                    >
                        <option v-for="startdesk in myStartdesks" v-bind:value="startdesk.id">{{ startdesk.name }}</option>
                    </select>

                    <nav class="has-margin-t15 is-clearfix">
                        <a class="btn is-primary is-pulled-left" v-on:click="copy">{{ __('Copy') }}</a>
                    </nav>

                    <span class="view__separator has-margin-t30">
                        <span>{{ __('or') }}</span>
                    </span>

                    <label class="form__label" v-bind:for="'copyToNewStartdesk' + tile.id">{{ __('Add to a new startdesk') }}</label>
                    <input class="form__control is-large" v-bind:id="'copyToNewStartdesk' + tile.id" type="text" autocomplete="off"
                           v-bind:placeholder="__('Enter startdesk name')"
                           v-model="startdeskName"
                    />

                    <nav class="has-margin-t15 is-clearfix">
                        <a class="btn is-primary is-pulled-left" v-on:click="add">{{ __('Add') }}</a>
                    </nav>

                </div>

                <nav class="has-margin-t30 is-clearfix">
                    <a class="btn is-pulled-right" v-on:click="closeModal">{{ __('Cancel') }}</a>
                </nav>
            </div>
        </div>
        <div class="modal__backdrop" v-on:click="closeModal"></div>
    </div>
</template>

<script>
    import { eventBus } from '../eventBus.js';

    export default {
        created: function () {
            // attach event listeners
            eventBus.$on('open-modal', this.openModal);
        },
        data: function () {
            return {
                isOpen: false,
                selectedStartdesk: null,
                startdeskName: ''
            }
        },
        methods: {
            add: function () {
                eventBus.$emit('show-loader');

                this.$http.post(this.apiUrl + '/startdesks', {
                    name: this.startdeskName,
                    user_id: this.user.id
                }).then(function (response) {
                    this.myStartdesks.push(response.body);

                    this.myStartdesks.sort(function(a, b) {
                        return  a.name.localeCompare(b.name);
                    });

                    let startdesk_id = response.body.id;
                    this.$http.post(this.apiUrl + '/tiles/clone/' + this.tile.id, {
                        startdesk_id: response.body.id
                    }).then(function (response) {
                        eventBus.$emit('hide-loader');

                        eventBus.$emit('show-alert', 'success', this.__('Tile has been successfully added.'));

                        this.closeModal();
                        
                        if (startdesk_id && startdesk_id != '') {
                            this.$http.post(this.apiUrl + '/startdesks/' + startdesk_id + '/screenshot');
                        }
                    }, function (response) {
                        if (response.status == 422 && response.body.errors) {
                            this.errors = response.body.errors;
                        }

                        eventBus.$emit('hide-loader');

                        eventBus.$emit(
                                'show-alert',
                                'error',
                                this.__('There were some errors validation the form. Please review and correct them.')
                        );

                        this.closeModal();
                    }.bind(this));
                }.bind(this), function (response) {
                    if (response.status == 422 && response.body.errors) {
                        this.errors = response.body.errors;
                    }

                    eventBus.$emit('hide-loader');

                    eventBus.$emit(
                            'show-alert',
                            'error',
                            this.__('There were some errors validation the form. Please review and correct them.')
                    );

                    this.closeModal();
                }.bind(this));
            },
            closeModal: function () {
                this.isOpen = false;
            },
            confirm: function () {
                eventBus.$emit('confirm', this.id);

                this.closeModal();
            },
            copy: function () {
                eventBus.$emit('show-loader');

                this.$http.post(this.apiUrl + '/tiles/clone/' + this.tile.id, {
                    startdesk_id: this.selectedStartdesk
                }).then(function (response) {
                    this.getStartdesks();

                    eventBus.$emit('hide-loader');

                    eventBus.$emit('show-alert', 'success', this.__('Tile has been successfully copied.'));

                    this.closeModal();
                        
                    if (this.selectedStartdesk && this.selectedStartdesk != '') {
                        this.$http.post(this.apiUrl + '/startdesks/' + this.selectedStartdesk + '/screenshot');
                    }
                }, function (response) {
                    if (response.status == 422 && response.body.errors) {
                        this.errors = response.body.errors;
                    }

                    eventBus.$emit('hide-loader');

                    eventBus.$emit(
                            'show-alert',
                            'error',
                            this.__('There were some errors validation the form. Please review and correct them.')
                    );

                    this.closeModal();
                }.bind(this));
            },
            openModal: function (id) {
                if (this.id == id) {
                    this.isOpen = true;
                }
            }
        },
        props: {
            id: {
                required: true,
                type: [Number, String]
            },
            tile: {
                required: null,
                type: Object
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/CopyTile.vue